<script>
	export let label = '';
	export let name;
	export let value = '';
	export let className = '';
	export let errors = [];

	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, value, className, errors, ...rest }) => rest)($$props);
</script>

<div class={className}>
	<div class="flex justify-between">
		{#if label}
			<label class="form-label" for={name}>{label}</label>
		{/if}
		<slot />
	</div>

	<textarea
		id={name}
		{name}
		{...props}
		bind:value
		class="form-input focus:outline-none"
		class:text-light={props.disabled}
		class:error={errors && errors.length}
	/>

	{#if errors && errors.length}
		<div class="form-error">{errors[0]}</div>
	{/if}
</div>
